import { parse, serialize } from "cookie";
//#region src/implementations/memory-token-store.ts
/**
* Keeps the token in a closure variable only.
*
* The token is lost on page reload, which is intentional: the long-lived
* credential lives in an httpOnly cookie, so a reload can silently recover a
* new short-lived token without ever exposing one to persistent storage.
*/
var MemoryTokenStore = class {
	token = null;
	listeners = /* @__PURE__ */ new Set();
	read() {
		return this.token;
	}
	write(token) {
		this.token = token;
		this.notify();
	}
	clear() {
		this.token = null;
		this.notify();
	}
	subscribe(listener) {
		this.listeners.add(listener);
		return () => {
			this.listeners.delete(listener);
		};
	}
	notify() {
		for (const listener of this.listeners) listener();
	}
};
function createMemoryTokenStore() {
	return new MemoryTokenStore();
}
//#endregion
//#region src/services/session-cookie.ts
/**
* Builds the Set-Cookie value that stores a session credential.
*
* httpOnly is applied unconditionally.
*/
function serialiseSessionCookie(value, options) {
	return serialize(options.name, value, {
		httpOnly: true,
		secure: options.secure,
		sameSite: options.sameSite,
		path: options.path,
		maxAge: options.maxAgeSeconds,
		...options.domain === void 0 ? {} : { domain: options.domain }
	});
}
/**
* Builds the Set-Cookie value that removes a session credential.
*
* The attributes must match those used when the cookie was set, otherwise the
* browser treats it as a different cookie and leaves the original in place.
*/
function serialiseClearedSessionCookie(options) {
	return serialize(options.name, "", {
		httpOnly: true,
		secure: options.secure,
		sameSite: options.sameSite,
		path: options.path,
		maxAge: 0,
		...options.domain === void 0 ? {} : { domain: options.domain }
	});
}
function readSessionCookie(cookieHeader, name) {
	if (!cookieHeader) return null;
	return parse(cookieHeader)[name] ?? null;
}
//#endregion
export { createMemoryTokenStore, readSessionCookie, serialiseClearedSessionCookie, serialiseSessionCookie };

//# sourceMappingURL=index.mjs.map